<button class="btn btn-primary" [ngClass]="{ 'btn-block': data().btnBlock }" [loadingFn]="save()">
  {{ data().buttonText || "Speichern" }}
</button>
